// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ItsmeButton_reset-list_3J_tP{margin:0;padding:0;list-style:none;display:block}.ItsmeButton_uppercase-sm_1JYeG{font-size:12px;text-transform:uppercase;letter-spacing:.03667em}.ItsmeButton_icon_1R0eh{display:block;width:29px;height:auto;margin-right:8px}", ""]);
// Exports
exports.locals = {
	"reset-list": "ItsmeButton_reset-list_3J_tP",
	"uppercase-sm": "ItsmeButton_uppercase-sm_1JYeG",
	"icon": "ItsmeButton_icon_1R0eh"
};
module.exports = exports;
